export function formatViewers(count: number): string {
  if (count >= 10000) {
    return `${(count / 10000).toFixed(1)}万`;
  }
  return `${count}`;
}

export function formatCount(count: number): string {
  return count.toLocaleString("zh-CN");
}